export default "__VITE_ASSET__BanCGcfY__"